import type { SubHeadResponse } from '@cosvision/shared';
import { request } from '../api.js';

export interface ListSubHeadsOptions {
  includeInactive?: boolean;
}

export function listSubHeadsByFund(
  fundId: string,
  opts: ListSubHeadsOptions = {},
): Promise<SubHeadResponse[]> {
  return request<SubHeadResponse[]>('get', `/funds/${fundId}/sub-heads`, undefined, {
    params: opts.includeInactive ? { includeInactive: 'true' } : undefined,
  });
}
